<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";
import NoImageUrl from "@/assets/no-image.png";

export default {
	 components: {
		  Layout
         	 },
data() {
    return {
    style: null,
    NoImageUrl,
    orders: [],
    order:'',
    restaurant:{},

    tracking: {},
    cr_id:"",
    r_id: "",
    city:{},
    guest:[],
    restaurants:{},
    products: [],
    image:'',
    product:'',
    sigofood_guest:[],
    reasons:{
            },
    comments:'',
    reason:'',
    order_details:{},
    cancel: {
               order_id: '',
               reason: ''
            },
    center1: { 
            lat:"", 
            lng: "" 
            
         },
    center2: { 
            lat:"", 
            lng: "" 
            
         },
    location: {
        area: "",
    },     
        
    errors:{},
    locations: [],
    currentLocation: null,
    markerOptions: {
            size: {width: 50, height: 50, f: 'px', b: 'px'},
            scaledSize: {width: 50, height: 50, f: 'px', b: 'px'},
         },

    latitude: 0,
    longitude: 0,      
    active_order_id:0,
    track_status: 1,
    driver: {
        name: '',
    },

    step: 0,
    draft_orders: [],
    completed_orders: [],
       
    };

    
  },
  
	 created() {
		  this.style = document.createElement('link')
		  this.style.setAttribute('rel', 'stylesheet')
		  this.style.setAttribute('href', '/design/orders.css')
		  document.head.appendChild(this.style)
	 },

     beforeDestroy() {
        document.head.removeChild(this.style);
    },
      mounted() {
        this.fetchDraftOrders();
        this.fetchCompletedOrders();
        // this.fetchOrderDetails();
        this.fetchReasons();
        // this.orderTracking();

  },


    methods: {
        getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				if(sigofood_user.token) {
					this.token = sigofood_user.token;
					this.uid = sigofood_user.uid;
					this.user_id = sigofood_user.user_id;
					// console.log(this.token);
					// console.log(this.uid);
					// console.log(this.user_id);

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
				
			} else if(localStorage.getItem('sigofood_guest')){
				var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
				if(sigofood_guest.token) {
				this.guestToken = sigofood_guest.token;
				this.guest_id = sigofood_guest.guest_id;
					// console.log(this.device_token);
					// console.log(this.guest_id);
					

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			}else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
      	}, 


        fetchDraftOrders() {
            this.getToken();

            if(this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

                let url = "orders/draft_orders?uid="+this.uid+ "&device_token=" +this.device_token;
                this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })

                    .then((res) => {
                        var responseData = res.data;
                        
                        console.log(this.orders);
                        if(responseData.data.length) {
                            this.orders = responseData.data;
                            this.draft_orders = responseData.data;
                            this.fetchOrderDetails(this.orders[0].order_id, this.orders[0].r_id);
                        }
                        
                })         
                .catch((error) => {
                    if (error.response) {
                        if(error.response.status == 422) {               
                            if (error.response.data) {
                            this.errors = error.response.data.message;
                            } 
                            this.$swal("", error.response.statusText, "error");
                            
                        } else if(error.response.status == 500) {
                            this.$swal("", error.response.statusText, "error");

                        } else if(error.response.status == 401) {
                            this.$swal("", error.response.statusText, "error");
                            this.$router.push({ name: "login" });
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", error.message, "error");
                    }
                })
                .finally(() => (this.loading = false));

            } else {
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer ",
					},
				};
				let url = "orders/draft_orders?uid="+ this.guestToken + "&device_token=" + this.guestToken;
						
				this.$axios
					.get(url, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.orders = responseData.data;
                            this.draft_orders = responseData.data;
                            this.fetchOrderDetails(this.orders[0].order_id, this.orders[0].r_id);
							console.log(this.orders);
						} else {
							this.$swal("", "Something went wrong", "error");
						} 
					})
					.catch((error) => {
                        if (error.response) {
                            if(error.response.status == 422) {               
                                if (error.response.data) {
                                    this.errors = error.response.data.message;
                                } 
                                this.$swal("", error.response.statusText, "error");
                                            
                            } else if(error.response.status == 500) {
                                this.$swal("", error.response.statusText, "error");

                            } else if(error.response.status == 401) {
                                this.$swal("", error.response.statusText, "error");
                                this.$router.push({ name: "login" });
                                            
                                } else {
                                    this.$swal("", "Something went wrong", "error");
                                }
                        } else {
                            this.$swal("", error.message, "error");
                        }
					})
					.finally(() => (this.loading = false));
			}  
        },
	  
	    fetchCompletedOrders() {
            this.getToken();

            if(this.uid) {
                if(localStorage.getItem('sigofood_uid')) {
                        this.uid = localStorage.getItem('sigofood_uid');  
                    } 

                let url = "orders/completed_orders?uid="+this.uid+ "&device_token=" +this.device_token;
                this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })

                    .then((res) => {
                        var responseData = res.data;
                        this.completed_orders = responseData.data;
                        console.log(this.orders);
                        // if(responseData.data.length) {
                        //     //this.orders = responseData.data;
                        //     //this.fetchOrderDetails(this.orders[0].order_id, this.orders[0].r_id);
                        // }
                        
                })         
                .catch((error) => {
                    if (error.response) {
                        if(error.response.status == 422) {               
                            if (error.response.data) {
                            this.errors = error.response.data.message;
                            } 
                            this.$swal("", error.response.statusText, "error");
                            
                        } else if(error.response.status == 500) {
                            this.$swal("", error.response.statusText, "error");

                        } else if(error.response.status == 401) {
                            this.$swal("", error.response.statusText, "error");
                            this.$router.push({ name: "login" });
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", error.message, "error");
                    }
                })
                .finally(() => (this.loading = false));

            } else {
                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer ",
                    },
                };
                let url = "orders/completed_orders?uid="+ this.guestToken + "&device_token=" + this.guestToken;
                        
                this.$axios
                    .get(url, config)
                    .then((res) => {
                        if(res.status == 200) {
                            var responseData = res.data;
                            console.log(responseData);
                            //this.orders = responseData.data;
                            this.completed_orders = responseData.data;
                            //console.log(this.orders);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        } 
                    })
                    .catch((error) => {
                        if (error.response) {
                            if(error.response.status == 422) {               
                                if (error.response.data) {
                                    this.errors = error.response.data.message;
                                } 
                                this.$swal("", error.response.statusText, "error");
                                            
                            } else if(error.response.status == 500) {
                                this.$swal("", error.response.statusText, "error");

                            } else if(error.response.status == 401) {
                                this.$swal("", error.response.statusText, "error");
                                this.$router.push({ name: "login" });
                                            
                                } else {
                                    this.$swal("", "Something went wrong", "error");
                                }
                        } else {
                            this.$swal("", error.message, "error");
                        }
                    })
                    .finally(() => (this.loading = false));
            }  
        }, 

        setDraftOrders()  {
            //alert('draft');
            this.orders = this.draft_orders;
            this.step = 0;
            this.order_details = {};
            if(this.orders.length) {
                this.fetchOrderDetails(this.orders[0].order_id, this.orders[0].r_id);
            }
        },

        setCompletedOrders()  {
            //alert('completed');
            this.orders = this.completed_orders;
            this.step = 1;
            this.order_details = {};
            if(this.orders.length) {
                this.fetchOrderDetails(this.orders[0].order_id, this.orders[0].r_id);
            }
        },

        fetchOrderDetails(order_id, r_id) {
            this.getToken(); 
            
            if(this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

                let url = "orders/getOrderDetails";  

                let formData = new FormData();
                formData.append("device_token", this.uid);
                formData.append("uid", this.uid);
                formData.append("order_id", order_id);
                formData.append("r_id", r_id);

                this.$axios
                .post(url, formData, config)
                .then((response) => {
                        if (response.data.status) {
                        var responseData = response.data;
                        this.order_details = responseData.data;
                        this.products = responseData.data.products;
                        this.active_order_id = order_id;
                        console.log(this.order_details);
                        console.log(this.products);
                
                        this.center1.lat = parseFloat(this.order_details.restaurant.latitude);
                        this.center1.lng = parseFloat(this.order_details.restaurant.longitude);

                        if(this.order_details.status == 'pending') {
                            this.track_status = 1;
                        } else if(this.order_details.status == 'processing') {
                            this.track_status = 2;
                        } else if(this.order_details.status == 'dispatched') {
                            this.track_status = 3;
                        } else if(this.order_details.status == 'delivered') {
                            this.track_status = 4;
                        } else {
                            this.track_status = 5;
                        }


                        this.$swal("", response.data.message, "success");
                        } else {
                        this.$swal("", response.data.message, "error");
                        }
                        this.clearForm();
                    //   this.$router.push({ name: 'customers'});
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));

            } else {
                const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer ",
					},
				};
				let url = "orders/getOrderDetails";  

                let formData = new FormData();
                formData.append("device_token", this.guestToken);
                formData.append("uid", this.guestToken);
                formData.append("order_id", order_id);
                formData.append("r_id", r_id);

                this.$axios
                .post(url, formData, config)
                .then((response) => {
                        if (response.data.status) {
                        var responseData = response.data;
                        this.order_details = responseData.data;
                        this.products = responseData.data.products;
                        console.log(this.order_details);
                        console.log(this.products);
                
                        this.center1.lat = parseFloat(this.order_details.restaurant.latitude);
                        this.center1.lng = parseFloat(this.order_details.restaurant.longitude);

                        if(this.order_details.status == 'pending') {
                            this.track_status = 1;
                        } else if(this.order_details.status == 'processing') {
                            this.track_status = 2;
                        } else if(this.order_details.status == 'dispatched') {
                            this.track_status = 3;
                        } else if(this.order_details.status == 'delivered') {
                            this.track_status = 4;
                        } else {
                            this.track_status = 5;
                        }


                        this.$swal("", response.data.message, "success");
                        } else {
                        this.$swal("", response.data.message, "error");
                        }
                        this.clearForm();
                    //   this.$router.push({ name: 'customers'});
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
				}  
        },

        cancelOrder() {
            this.getToken();  
            if(this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 
                const config = {
                    headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                    },
                };

                let url = "orders/cancelOrder";             
                let formData = new FormData();
                formData.append("uid", this.uid);
                formData.append("device_token","");
                formData.append("order_id", this.order_details.order_id); 
                formData.append("reason_id", this.cr_id); 
                formData.append("comments", this.comments); 

                this.hideModal('cancel-modal');
                this.fetchDraftOrders();

            
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        var responseData = response;
                        this.data = responseData;
                        console.log(this.data);

                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.clearForm();
                    //   this.$router.push({ name: 'customers'});
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));

            } else {
                const config = {
                    headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer ",
                    },
                };

                let url = "orders/cancelOrder";             
                let formData = new FormData();
                formData.append("uid", this.guestToken);
                formData.append("device_token", this.guestToken);
                formData.append("order_id", this.order_details.order_id); 
                formData.append("reason_id", this.cr_id); 
                formData.append("comments", this.comments); 

                this.hideModal('cancel-modal');
                this.fetchDraftOrders();

            
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        var responseData = response;
                        this.data = responseData;
                        console.log(this.data);

                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.clearForm();
                    //   this.$router.push({ name: 'customers'});
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            }    
        },

         
        clearForm() {           
            this.order_id = "";
            this.reason_id = "";
            this.comments='';
            this.errors = {};
        },

        showModal(modal) {
            this.$refs[modal].show();
        },

        hideModal(modal) {
            this.$refs[modal].hide();
            this.fetchDraftOrders();
        },    

        
        setCancel(order_id) {
            this.order_id = order_id;
            this.showModal('cancel-modal');
        },

        fetchReasons() {           
	
            let url =
                "orders/getCancelReasons?&reason_for=" +
                'Customer'+
                "&status=" +1 ;

            this.$axios
                    .get(url)

                .then((res) => {
                var responseData = res.data;
                this.reasons = responseData.data;

                console.log(this.reasons);

                })
                .catch((err) => console.log(err));
        },
	 
        orderTracking(order_id) {
            this.getToken();  
                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                     "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "orders/tracking";             
            let formData = new FormData();
            formData.append("order_id", order_id);
            
           
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
					var responseData = response.data;
                     console.log(response);
                    this.tracking = responseData.data;
                    this.location = responseData.data.location;
                    this.driver = responseData.data.driver;
                    this.latitude = responseData.data.location.latitude;
                    this.longitude = responseData.data.location.longitude;
                    // this.center2.lat = parseFloat(this.tracking.location.latitude);
                    // this.center2.lng = parseFloat(this.tracking.location.longitude);
                    console.log(this.tracking);
                    console.log(this.location);

                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
               })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                    } else {
                     this.$swal("", "Something went wrong", "error");
                    }
                })
               .finally(() => (this.loading = false));
        },

        getMapUrl() {
            return `https://maps.google.com/maps?q=${this.latitude},${this.longitude}&z=15&output=embed`;
        },
         
        
		fetchLocation() {

			if (localStorage.getItem('sigofood_location')) {
									var sigofood_location =  JSON.parse(localStorage.getItem('sigofood_location'));
					this.latitude = sigofood_location.latitude;
                    					this.longitude = sigofood_location.longitude;
					this.block_no = sigofood_location.block_no;

					this.location = sigofood_location;

                        console.log(this.location);


			} else {
                this.$router.push({ name: "location" });
            }
		}, 
         
      },
 };

</script>


<template>
    <layout>
        <div class="container">
            <h3 class="my-orders fw-semibold">My Orders</h3>
        </div><br><br>

        <div class="container">
            <div class="row" v-if="!draft_orders.length && !completed_orders.length">
                <div class="col-12 text-center py-5">
                    <img src="/design/sigofood-images/no_orders.png">
                    <p>No orders found</p>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-xl-6 col-lg-12 col-md-12 orders">

                    <div id="exTab1" >
                        <!-- <ul class="nav nav-pills nav-fill" role="tablist">                            
                            <li class="nav-item me-2" role="presentation">
                                 <a href="#" class="nav-link active text-dark" id="draft-tab" data-bs-toggle="tab" data-bs-target="#draft-content" role="tab" @click="order_details={}">Draft Orders
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                 <a href="#" class="nav-link text-dark" id="completed-tab" data-bs-toggle="tab" data-bs-target="#completed-content" role="tab" @click="order_details={}">Completed Orders
                                </a>
                            </li>

                        </ul><br>

                        
                        <div class="tab-content">
                            <div class="tab-pane active" id="draft-content" role="tabpanel" aria-labelledby="draft-tab">
                                <div class="" v-if="orders.length">
                                <div class="card single-order mb-4"  v-bind:class="{ 'active': order.order_id==active_order_id }" v-for="order in orders" :key="order.order_id" data-bs-toggle="tab" data-bs-target="#profile-content">
                                    <div class="row g-0"   @click="fetchOrderDetails(order.order_id, order.r_id)">
                                        
                                        <div class="col-lg-8 d-flex">
                                            <div class="imgbox">      
                                                <div v-if="order.image" :style="{ 'background-image': 'url(' + $image_url + order.image + ')' }" ></div>
                                                <div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
                                            </div>
                                            
                                            <div class="col p-3">
                                                <h5 class="order-restaurant">{{order.rest_name}}</h5>
                                                <p class="card-text"><small class="text-muted">{{order.rest_city}}, {{order.rest_country}}</small></p>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 p-3">
                                            <div class="col text-end">
                                                <button class="track-order" data-bs-toggle="modal" data-bs-target="#exampleModal1" @click="orderTracking(order.order_id)">Track Order</button>
                                            </div>
                                        </div>
                                    </div>
                                        
                                    <div class="row p-2">
                                        <div class="col-lg-8">
                                            <div class="date-bhd">
                                                <sub style="max-width: 130px; font-weight: 400;">{{order.timestamp | formatDateTime}}</sub>
                                            
                                                <p class="bhd ps-3">BHD {{parseFloat(order.total).toFixed(2)}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 order-status">
                                            <p class="float-end pe-2">Status: <strong>{{order.status}}</strong></p>
                                        </div>
                                    </div>

                                </div>
                                </div>
                                <div class="" v-else>
                                    <p>No orders found</p>
                                </div>
                            </div>

                            <div class="tab-pane" id="completed-content" role="tabpanel" aria-labelledby="completed-tab" v-for="order in orders" :key="order.order_id">
                                <div class="card mb-4 shadow-sm" data-bs-toggle="tab" data-bs-target="#profile-content"  @click="fetchOrderDetails(order.order_id, order.r_id)">
                                    <div class="row g-0" v-if="(order.status=='delivered')">
                                        <div class="col-md-2 p-2 imgbox">
                                            <img src="/design/sigofood-images/dq.png" class="img-fluid " alt="chicken-burger">
                                        </div>
                                        <div class="col-md-10">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col">
                                                        <h5 class="card-title">{{order.rest_name}}</h5>
                                                    </div>
                                                    <div class="col text-end">
                                                        <button class="track-order" data-bs-toggle="modal"
                                                            data-bs-target="#exampleModal1">Track Order</button>
                                                    </div>
                                                </div>
                                                <p class="card-text"><small class="text-muted"> {{order.rest_address}}, {{order.rest_city}} </small></p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xl-4">
                                                <p>{{order.timestamp}}</p>
                                            </div>
                                            <div class="col-xl-4 bhd">
                                                <p> {{parseFloat(order.total).toFixed(2)}} BHD</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="completed-content" role="tabpanel" aria-labelledby="completed-tab">
                                <div class="" v-if="orders.length">
                                <div class="card single-order mb-4"  v-bind:class="{ 'active': order.order_id==active_order_id }" v-for="order in orders" :key="order.order_id" data-bs-toggle="tab" data-bs-target="#profile-content">
                                    <div v-if="(order.status=='delivered')">
                                    <div class="row g-0"   @click="fetchOrderDetails(order.order_id, order.r_id)">
                                        
                                        <div class="col-lg-8 d-flex">
                                            <div class="imgbox">      
                                                <div v-if="order.image" :style="{ 'background-image': 'url(' + $image_url + order.image + ')' }" ></div>
                                                <div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
                                            </div>
                                            
                                            <div class="col p-3">
                                                <h5 class="order-restaurant">{{order.rest_name}}</h5>
                                                <p class="card-text"><small class="text-muted">{{order.rest_city}}, {{order.rest_country}}</small></p>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 p-3">
                                            <div class="col text-end">
                                                <button class="track-order" data-bs-toggle="modal" data-bs-target="#exampleModal1" @click="orderTracking(order.order_id)">Track Order</button>
                                            </div>
                                        </div>
                                    </div>
                                        
                                    <div class="row p-2">
                                        <div class="col-lg-8">
                                            <div class="date-bhd">
                                                <sub style="max-width: 130px;">{{order.timestamp | formatDateTime}}</sub>
                                            
                                                <p class="bhd ps-3">BHD {{parseFloat(order.total).toFixed(2)}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 order-status">
                                            <p class="float-end pe-2">Status: <strong>{{order.status}}</strong></p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                <div class="" v-else>
                                    <p>No orders found</p>
                                </div>
                            </div>
                        </div> -->
                        <!-- <button v-on:click="step = 0">Step 1</button>
                        <button v-on:click="step = 1">Step 2</button>
                        <button v-on:click="step = 2">Step 3</button> -->

                        <b-tabs v-model="step">
                            <b-tab title="Draft Orders" @click="setDraftOrders()">
                               <div class="" v-if="orders.length">
                                <div class="card single-order mb-4"  v-bind:class="{ 'active': order.order_id==active_order_id }" v-for="order in orders" :key="order.order_id" data-bs-toggle="tab" data-bs-target="#profile-content">
                                    <div class="row g-0"   @click="fetchOrderDetails(order.order_id, order.r_id)">
                                        
                                        <div class="col-lg-8 d-flex">
                                            <div class="imgbox">      
                                                <div v-if="order.image" :style="{ 'background-image': 'url(' + $image_url + order.image + ')' }" ></div>
                                                <div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
                                            </div>
                                            
                                            <div class="col p-3">
                                                <h5 class="order-restaurant">{{order.rest_name}}</h5>
                                                <p class="card-text"><small class="text-muted">{{order.rest_city}}, {{order.rest_country}}</small></p>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 p-3">
                                            <div class="col text-end">
                                                <button class="track-order" data-bs-toggle="modal" data-bs-target="#exampleModal1" @click="orderTracking(order.order_id)">Track Order</button>
                                            </div>
                                        </div>
                                    </div>
                                        
                                    <div class="row p-2">
                                        <div class="col-lg-8">
                                            <div class="date-bhd">
                                                <sub style="max-width: 130px; font-weight: 400;">{{order.timestamp | formatDateTime}}</sub>
                                            
                                                <p class="bhd ps-3">BHD {{parseFloat(order.total).toFixed(2)}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 order-status">
                                            <p class="float-end pe-2">Status: <strong>{{order.status}}</strong></p>
                                        </div>
                                    </div>

                                </div>
                                </div>
                                <div class="" v-else>
                                    <p>No draft orders found</p>
                                </div>
                            </b-tab>
                            <b-tab title="Completed Orders" @click="setCompletedOrders()">
                                <div class="" v-if="orders.length">
                                <div class="card single-order mb-4"  v-bind:class="{ 'active': order.order_id==active_order_id }" v-for="order in orders" :key="order.order_id" data-bs-toggle="tab" data-bs-target="#profile-content">
                                    <div v-if="(order.status=='delivered')">
                                    <div class="row g-0"   @click="fetchOrderDetails(order.order_id, order.r_id)">
                                        
                                        <div class="col-lg-8 d-flex">
                                            <div class="imgbox">      
                                                <div v-if="order.image" :style="{ 'background-image': 'url(' + $image_url + order.image + ')' }" ></div>
                                                <div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
                                            </div>
                                            
                                            <div class="col p-3">
                                                <h5 class="order-restaurant">{{order.rest_name}}</h5>
                                                <p class="card-text"><small class="text-muted">{{order.rest_city}}, {{order.rest_country}}</small></p>
                                            </div>
                                        </div>

                                        <div class="col-lg-4 p-3">
                                            <div class="col text-end">
                                                <button class="track-order" data-bs-toggle="modal" data-bs-target="#exampleModal1" @click="orderTracking(order.order_id)">Track Order</button>
                                            </div>
                                        </div>
                                    </div>
                                        
                                    <div class="row p-2">
                                        <div class="col-lg-8">
                                            <div class="date-bhd">
                                                <sub style="max-width: 130px;">{{order.timestamp | formatDateTime}}</sub>
                                            
                                                <p class="bhd ps-3">BHD {{parseFloat(order.total).toFixed(2)}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 order-status">
                                            <p class="float-end pe-2">Status: <strong>{{order.status}}</strong></p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                <div class="" v-else>
                                    <p>No completed orders found</p>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>                    
                </div>

                <div class="col-xl-6 col-lg-12 col-md-12 order-details" id="profile-content" v-if="order_details.order_id">
                    <div >
                        <div>
                            <h4 class="text-center fw-semibold mb-3">Order Details</h4>
                            <h5 Class="text-center fw-semibold">Estimate Delivery Time</h5>
                            <h5 Class="text-center fw-semibold time">{{order_details.timestamp | formatDateTime}}</h5>
                            <hr>
                            <div class="row ">
                                <div class="col ">
                                    <button class="btn track-button" data-bs-toggle="modal" data-bs-target="#exampleModal1" @click="orderTracking(order_details.order_id)">Track
                                        Order</button>
                                </div>
                                <div class="col">
                                    <button class=" cancel" data-bs-toggle="modal" data-bs-target="#exampleModal2" @click="setCancel(order_details.customer_order_id)">Cancel
                                        Order</button>
                                </div>
                            </div><br>
                            <br>

                            <h6 class="fw-semibold" style="text-transform: capitalize;">{{order_details.rest_name}}</h6>
                            <div class="row" v-for="product in products" :key="product.product_id">
                                <div class="col-2">
                                    <!-- <p>1 x</p> -->
                                    <p>{{product.quantity}} x</p>
                                </div>
                                <div class="col">
                                    <!-- <p>Hotdog</p> -->
                                    <p>{{product.product_name}}</p>
                                </div>
                                <div class="col">
                                    <!-- <p>BHD 7.250</p> -->
                                    <p>BHD {{product.total}}</p>
                                </div>
                            </div><br>
                            <h6 class="fw-semibold">Payment Summary</h6>
                            <div class="row">
                                <div class="col">
                                    <p>Sub total</p>
                                </div>
                                <div class="col text-end">
                                    <p>BHD{{parseFloat(order_details.subtotal).toFixed(2)}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p>Delivery Fee</p>
                                </div>
                                <div class="col text-end" >
                                    <p>BHD{{parseFloat(order_details.delivery_charge).toFixed(2)}}</p>
                                </div>
                            </div><br>
                            <div class="row">
                                <div class="col">
                                    <h6 class="fw-semibold">Total Amount</h6>
                                </div>
                                <div class="col" style="; margin-bottom: 20px;">
                                    <h6 class="fw-semibold text-end">BHD{{parseFloat(order_details.total).toFixed(2)}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
        </div>

    <div class="modal fade" id="exampleModal1" tabindex="50" aria-labelledby="exampleModalLabel1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header" style="border: none; padding: 10px 10px 0 0;">
                    <button type="button" class="btn-close float-end"  data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                
                <div class="modal-body track">
                    
                    <center>
                        <h4 class="mb-3">Track Your Order</h4>
                        <h5 class="mb-1">Estimate Delivery Time</h5>
                        <h5 class="time">{{tracking.timestamp | formatDateTime}}</h5>
                    </center>
                    <hr>
                    <div class="p-3">
                        <div class="row">
                            <div class="col-2">
                                <div class="rider">
                                    <h1 class="r">R</h1>
                                </div>
                            </div>
                            <div class="col rasel">
                                <h6>Your Rider</h6>
                                <!-- <h4>Rasel</h4> -->
                                <h4>{{driver.name}}</h4>
                            </div>
                        </div><br>
                        <div class="mapouter rider-map">
                            <div class="gmap_canvas">
                                    <iframe class="gmap_iframe" width="100%" frameborder="0" scrolling="no" marginheight="0"
                                    marginwidth="0" :src="getMapUrl()"></iframe >
                                <!-- <iframe class="gmap_iframe" width="100%" frameborder="0" scrolling="no" marginheight="0"
                                    marginwidth="0"
                                    src="https://maps.google.com/maps?width=704&amp;height=128&amp;hl=en&amp;q=manama&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                                <a href="https://piratebay-proxys.com/">Pirate bay proxy</a> -->
                            </div>
                        </div><br><br>
    
                        <div>
                            
                            <ul class="events">
                                <li class="star" v-bind:class="{ 'active': Boolean(track_status>=1) }">
                                  <time ></time> 
                                  <p>Order Pending</p></li>
                                  
                                <li class="star" v-bind:class="{ 'active': Boolean(track_status>=2) }">
                                  <time ></time> 
                                  <p>Order Confirmed</p></li>
                                
                                <li class="star" v-bind:class="{ 'active': Boolean(track_status>=3) }">
                                  <time ></time> 
                                  <p>Rider is on the way</p></li>
                                
                                <li class="star" v-bind:class="{ 'active': Boolean(track_status>=4) }">
                                  <time></time> 
                                  <p>Rider is nearby your place</p></li>
                                
                              </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <b-modal ref="cancel-modal" id="cancel-modal" title="Cancel Order" hide-footer @hidden="clearForm()">
        <b-form @submit.prevent="cancelOrder()">
            <b-row>  
                <div class="modal-body">
                    <select class="form-select fw-semibold" aria-label="Default select example" v-model="cr_id" @change="fetchReasons()" >
                        <option value="">Choose cancel reason</option>
                        <option :value="reason.cr_id" v-for="reason in reasons" :key="reason.cr_id">{{reason.reason}}</option>
                    </select><br>

                    <b-form-input  v-model="comments" placeholder="Add Comment"></b-form-input>
                        <div v-for="(val, index) in errors.reason" :key="index" class="invalid-feedback">
                            <p class="mb-0">{{ val }}</p>
                        </div>
                </div>

                <div class="modal-footer"><br>
                    <b-button class="" variant="light" @click="hideModal('cancel-modal')">Close</b-button>
                    <b-button type="submit" class="me-3"  variant="primary">Confirm</b-button>
                </div><br>
            </b-row>
        </b-form>
    </b-modal>

    <br>
    <!-- <div class="container-sm">
         <div class="row">
            <div class="col-xl-4">
               <div class="column">
                  

                  <div class="col profile-card">
                     <div class="card profile">
                        <div class="card-body">                          
                           <ul class="nav flex-column" role="tablist">
                              <li class="nav-item" role="presentation">
                                 <a href="#" class="nav-link active text-dark" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-content" role="tab">
                                    <br>
                                 </a>
                              </li>
                              <li class="nav-item" role="presentation">
                                 <a href="#" class="nav-link text-dark" id="address-tab" data-bs-toggle="tab" data-bs-target="#address-content" role="tab"></a>
                              </li>
                              <li class="nav-item" role="presentation">
                                 <a href="#" class="nav-link text-dark" id="email-tab" data-bs-toggle="tab" data-bs-target="#email-content" role="tab"></a>
                              </li>
                              <li class="nav-item" role="presentation">
                                 <a href="#" class="nav-link text-dark" id="password-tab" data-bs-toggle="tab" data-bs-target="#password-content" role="tab"></a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                    
               </div>
            </div>

            <div class="col-xl">              

               <div class="tab-content">
                  <div class="tab-pane active" id="profile-content" role="tabpanel" aria-labelledby="profile-tab">
                     
                  </div>
                  <div class="tab-pane" id="address-content" role="tabpanel" aria-labelledby="address-tab">
                     
                  </div>
                  <div class="tab-pane" id="email-content" role="tabpanel" aria-labelledby="email-tab">
                     
                  </div>
                  <div class="tab-pane" id="password-content" role="tabpanel" aria-labelledby="password-tab">
                     
                  </div>
               </div>
            </div>
        </div>
    </div> -->
    </layout>
</template>

